class QuizApp {
  constructor() {
    this.el = document.querySelector('.app-quiz')
    this.questionCount = this.el?.querySelectorAll('.js-app-quiz-question')?.length
    this.clickedCount = 0
    this.points = 0
  }

  /**
   * Initialize quiz
   */
  init() {
    if (this.el) {
      this.addListeners()
    }
  }

  /**
   * Add listeners to inputs
   */
  addListeners() {
    const inputs = this.el.querySelectorAll('input')
    if (inputs) {
      inputs.forEach(input => {
        input.addEventListener('click', () => {
          const desc = input.closest('li').querySelector('.js-app-quiz-answer-description');
          const questionEl = input.closest('.js-app-quiz-question')
          const correct = input.value === '1'
          questionEl.querySelectorAll('input').forEach((el) => {
            el.setAttribute('disabled', true)
          })
          if (!correct) {
            questionEl.classList.add('wrong')
          }
          if (desc) {
            questionEl.insertAdjacentHTML('beforeend', `<div style="display: block;" class="description">${desc.innerHTML}</div>`)
          }
          this.clickedCount = this.clickedCount + 1
          if (input.value === '1') {
            this.points = this.points + 1
          }
          this.refreshStatus()
        })
      })
    }
  }

  /**
   * Refresh status of the quiz (if last question show result)
   */
  refreshStatus() {
    if (this.clickedCount >= this.questionCount) {
      this.el.querySelectorAll('.js-app-quiz-question').forEach((question) => {
        question.style.display = 'none'
      })
      this.el.querySelectorAll('.js-app-quiz-result').forEach((result) => {
        const min = result.getAttribute('data-points-min')
        const max = result.getAttribute('data-points-max')
        if (this.points >= min && this.points <= max) {
          document.querySelector('.main-content-area').innerHTML = result.innerHTML
        }
      })
    }
  }
}

export default new QuizApp()
